import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  Grid,
  InputAdornment,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

import { TP_COLORS } from '../../../../../constants';
import {
  gridTitleProps,
  searchFieldProps,
  TState,
} from '../modals/AddSubjectModal';
import { TPTextField } from '../../../../../components/Inputs';
import { IGrade } from '../../../../../store/V2/SubjectSlice';

interface SelectGradeProps {
  state: TState;
  handleGradeCheck: (gradeItem: IGrade) => void;
}

const SelectGrade: React.FC<SelectGradeProps> = ({
  state,
  handleGradeCheck,
}) => {
  // State
  const [gradeList, setGradeList] = useState<IGrade[]>([]);

  useEffect(() => {
    setGradeList(state.selectedCurriculum?.grades || []);
  }, [state.selectedCurriculum]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (state.selectedCurriculum?.grades?.length) {
      const filteredGrades = state.selectedCurriculum.grades.filter(
        ({ grade }) => grade.toLowerCase().includes(value.toLowerCase())
      );

      setGradeList(filteredGrades);
    }
  };

  return (
    <Grid item xs={12} sm={4}>
      <Typography {...gridTitleProps}>Grades</Typography>
      <TPTextField
        {...searchFieldProps}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        onChange={handleInputChange}
      />

      <List
        sx={{
          overflow: 'auto',
          height: { md: '370px' },
        }}
      >
        {gradeList.length ? (
          gradeList.map((gradeItem, index) => {
            return (
              <ListItemButton
                key={index}
                role={undefined}
                onClick={() => handleGradeCheck(gradeItem)}
                dense
              >
                <ListItemText
                  primary={gradeItem.grade}
                  primaryTypographyProps={{
                    variant: 'subtitle2',
                    className: 'ellipsis-text',
                    color: TP_COLORS.gray.darken,
                  }}
                />
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={state.selectedGrades.some(
                      (item) => item.grade === gradeItem.grade
                    )}
                    tabIndex={-1}
                    disableRipple
                  />
                </ListItemIcon>
              </ListItemButton>
            );
          })
        ) : (
          <Stack height="100%" justifyContent="center" alignItems="center">
            <Typography variant="subtitle2" color={TP_COLORS.gray.darken}>
              Select a Curriculum
            </Typography>
          </Stack>
        )}
      </List>
    </Grid>
  );
};

export default SelectGrade;
